<template>
  <div class="container-box">
      <div class="flex align-center just-between" style="background:#409eff;color: #fff;font-size:16px;height:90px;line-height:90px;padding:0 40px;">
        <div style="height:60px;width:400px;margin-right:20px;">
          <img style="width:100%;height:100%;" :src="systemConfig.logoFile.url" alt="">
        </div>
        <div class="cursor-pointer" @click="logout">
          <span class="iconfont icontuichudenglu"></span>
          退出登录
        </div>
      </div>
      <div class="flex">
        <div class="flex" style="width:12%;">
          <div style="color:#fff;width:100%;">
            <el-menu
              :default-active='defaultActive'
              @open="handleOpen"
              @select="handleSelect"
              @close="handleClose">
              <el-submenu index="1">
                  <template slot="title">
                      <i class="el-icon-location"></i>
                      <span>网站配置</span>
                  </template>
                  <el-menu-item index="/xtsz">系统设置</el-menu-item>
                  <el-menu-item index="/website/infoItem">信息条目</el-menu-item>
                  <!-- <el-menu-item index="/sylbt">首页轮播图</el-menu-item> -->
                  <el-menu-item index="/tpclj">图片超链接</el-menu-item>
                  <el-menu-item index="/lmwh">栏目维护</el-menu-item>
                  <el-menu-item index="/website/deptDutyPage">职责分工</el-menu-item>
                  <el-menu-item index="/website/serviceCenterPage">服务中心维护</el-menu-item>
              </el-submenu>
              <el-menu-item index="/publishNews">
                  <i class="el-icon-plus"></i>
                  <span slot="title">发布通知</span>
              </el-menu-item>
              <el-menu-item index="/userManage">
                  <i class="el-icon-menu"></i>
                  <span slot="title">用户管理</span>
              </el-menu-item>
              <el-menu-item index="/whiteListManage">
                  <i class="el-icon-menu"></i>
                  <span slot="title">白名单管理</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div style="width:88%;background:#f4f4f5;min-height:89vh;padding:20px;">
          <router-view></router-view>
        </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
// eslint-disable-next-line no-unused-vars
// import echart from 'echarts'
/* eslint-disable prefer-const */
/* eslint-disable no-var */
// import HeaderBox from '../components/HeaderBox'
import qs from 'qs'

export default {
  components: {
    // HeaderBox
  },
  data () {
    return {
      defaultActive: '/xtsz',
      systemConfig: {
        logoFile: {
          url: ""
        }
      }
    }
  },
  methods: {
    handleOpen () {

    },
    handleClose () {

    },
    logout() {
			this.$confirm("此操作将退出登录, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$api.login.logout().then(res => {
						localStorage.clear();
						this.$message({
							type: "success",
							message: "退出成功!"
						});
						this.$router.push({
							path: "/login"
						});
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "取消退出"
					});
				});
		},
    handleSelect (key, keypath) {
        localStorage.setItem('defaultPath', key)
        const path = '/manage' + key
        this.$router.push({
            path: path
        })
    },
    getSystemConfig() {
      this.$api.index.getSystemConfig().then(res => {
        if (res.code === 200) {
          this.systemConfig = res.data;
        }
      })
    }
  },
  created() {
  },
  mounted () {
    if (localStorage.getItem('defaultPath')) {
      this.defaultActive = localStorage.getItem('defaultPath')
    };
    this.getSystemConfig();
  }
}
</script>

<style scoped lang='less'>
.active-back{
    background: linear-gradient(360deg, #2562F3 0%, #00D0FE 100%);
}
.container-box{
  // background:rgb(0, 2, 11);
  min-width: 1366px;
  min-height:100vh;
}
.el-dialog{
    font-size:16px;
}
.el-dialog__body{
    padding: 10px 40px !important;
}
/deep/ .dc-btn{
    background: #2562F3;
    color: #fff;
    position: relative;
    z-index: 100;
    width: 60px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.el-input__prefix{
  position: absolute;
  top: -5px;
}
.el-submenu .el-menu-item{
    min-width: 150px;
}
/deep/ .el-menu{
  height: 100%;
}
/deep/ .el-icon-circle-close {
  color: #000000 !important;
  font-weight: bold !important;
}
</style>
